import { DEV_DOMAIN_PATTERNS } from '@bridebook/toolbox/src/api/short-links/allowed-domains';
import { env } from '@bridebook/web/lib/env';

const PROXIES_AMOUNT = 10;
const proxyHosts = Array.from(
  { length: PROXIES_AMOUNT },
  (_, i) => `app-proxy-dev-${i + 1}.bridebook.com`,
);

const STATIC_HOSTS = [
  ...proxyHosts,
  'bridebook.com',
  'www.bridebook.com',
  'bridebook.co.uk',
  'app.bridebook.com',
  'app-proxy-dev.bridebook.com',
  'app-proxy-prod.bridebook.co.uk',
  'bb-web-dev.vercel.app',
  'bb-web-staging.vercel.app',
  'bridebookhq.vercel.app',
];

const knownHosts = new Set(
  [...STATIC_HOSTS, env.COUPLESIDE_URL]
    .map((entry) => {
      try {
        return entry?.includes('://') ? new URL(entry).host : entry;
      } catch {
        return entry ?? null;
      }
    })
    .filter(Boolean) as string[],
);

/**
 * Checks whether a hostname belongs to a known Bridebook property.
 *
 * In production, matches against an explicit set of known hosts.
 * In non-production builds, also matches dev patterns like any
 * vercel.app subdomain, ngrok tunnels, and Cloudflare tunnels.
 */
export function isKnownBridebookHost(host: string): boolean {
  if (knownHosts.has(host)) return true;
  if (!env.LIVE) {
    return DEV_DOMAIN_PATTERNS.some((pattern) => host.includes(pattern));
  }
  return false;
}
